import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Flags from "country-flag-icons/react/3x2";

import "./EPLPredictionCard.css";
import logoMap from "./epl-images";

const logos = logoMap();
function EPLPredictionCard(props) {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: props.name });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className="driver-prediction-card-container"
      ref={setNodeRef}
      style={style}
      faded={isDragging.toString()}
      {...props}
      {...attributes}
      {...listeners}
    >
      <div className="driver-prediction-card-country-container">
        <img
          className="driver-prediction-card-country-img"
          src={logos[props.data.name.toLowerCase()]}
          alt={props.data.name + " Logo"}
        ></img>
      </div>
      <div className="driver-prediction-card-name-container">
        <p className="driver-prediction-card-name-text">
          {props.data.name.toUpperCase()}
        </p>
      </div>
      <div className="driver-prediction-card-team-container">
        <p className="driver-prediction-card-team-text">{props.data.team}</p>
      </div>
    </div>
  );
}

export default EPLPredictionCard;
